
<template>
    <v-dialog
    v-model="dialog"
    persistent
    fullscreen
    transition="dialog-bottom-transition">
        <div class="container-extras">
            <div class="header-extras">
                <span>Personalizar</span>

                <v-btn
                  class="btn-close-extra"
                  color="#FFFFFF"
                  variant="text"
                  @click="dialog=false">
                    <v-icon size="26">mdi-close</v-icon>
                </v-btn>

            </div>

            <div class="container-form-extras">

              <div class="row-exras-form">
                <span>{{ itemData.name }} (x{{ itemData.quantity }})</span>
                <span>${{ itemData.price * itemData.quantity }}</span>
              </div>

              <span>{{ itemData.description }}</span>

               <div class="row-exras-form">
                <span>
                  <v-icon >
                    mdi-clock-outline
                  </v-icon>
                  Entrega estimada
                </span>
               <span>{{ itemData.prep_time }} min</span>
              </div>

              <span style="font-weight: bold;"
              v-if="showDataExtras">
                Extras
              </span>
              <span v-if="showDataExtras">
                Agrega extras al producto:
              </span>

              <div class="grid-extras">
                <label v-for="item in itemData.extras" :key="item._id"
                class="lbl-extras">
                  <input
                    type="checkbox"
                    :value="item"
                    class="extras-checkbox"
                    v-model="extrasSelect"/>
                  <div class="row-lbl">
                    <span>{{ item.name }} </span>
                    <span>${{ item.price }}</span>
                  </div>
                </label>
              </div>

              <span style="font-weight: bold;">
                Agregar nota
              </span>

              <v-textarea
                v-model="note"
                density="compact"
                variant="solo"
                class="no-bg extras-textarea"
                rows="3"/>
            </div>

            <div class="container-btns-extras">

               <v-btn
                  style="width: 50%;"
                  color="#FF5700"
                  :disabled="disabledBtn()"
                  @click="addExtra()">
                  AGREGAR ${{getTotal()}}
                </v-btn>

                <v-btn
                  color="#FF5700"
                  variant="text"
                  style="width: 50%;"
                  @click="dialog = false">
                  Cerrar sin agregar
                </v-btn>

            </div>

        </div>
    </v-dialog>
</template>

<script>
export default {
  name: 'CommerciaVueNewOrderExtras',

  data () {
    return {
      dialog: false,
      itemData: null,
      extrasSelect: [],
      note: ''
    }
  },
  computed: {
    showDataExtras () {
      return this.itemData.extras_select.length > 0
    }
  },

  methods: {
    open (item) {
      console.log(item.extras)
      this.dialog = true
      this.extrasSelect = item.extras_select
      this.note = item.note || ''
      this.itemData = item
    },
    disabledBtn () {
      const sameExtras = JSON.stringify(this.itemData.extras_select) === JSON.stringify(this.extrasSelect)
      const sameNote = this.itemData.note === this.note
      return sameExtras && sameNote
    },
    addExtra () {
      this.itemData.extras_select = this.extrasSelect
      this.itemData.note = this.note
      this.dialog = false
    },
    getTotal () {
      return this.extrasSelect.reduce((total, item) => {
        return total + (item.price || 0)
      }, 0)
    }
  }

}
</script>

<style scoped>
    @import '@/assets/styles/extras.css';
    @import '@/assets/styles/inputs.css';
</style>
